import ValidatorHelper from 'viralstyle-ui/src/ValidatorHelper';

export default new ValidatorHelper({
  fullName: {
    rules: 'required',
    pretty: 'full name',
  },
  email: {
    rules: 'required|email',
    pretty: 'email address',
  },
  category: {
    rules: 'required',
    pretty: 'category',
  },
  message: {
    rules: 'required',
    pretty: 'message',
  },
});